import { Link } from "react-router-dom";
import { useLp, useT } from "../lib/i18n";

export function WhereAudioGoes() {
  const t = useT();
  const lp = useLp();
  const copy = t.whereAudioGoes;

  return (
    <section
      id="where-audio-goes"
      className="border-t border-margin bg-paper dark:border-paper/10 dark:bg-ink"
    >
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-20 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
        <div className="lg:sticky lg:top-24">
          <p className="text-xs font-medium uppercase tracking-wider text-ink/50 dark:text-paper/50">
            {copy.label}
          </p>
          <h2 className="mt-2 font-display text-3xl font-semibold tracking-tight text-ink dark:text-paper sm:text-4xl">
            {copy.heading}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-ink/70 dark:text-paper/70">
            {copy.description}
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to={lp + "/privacy"}
              className="inline-flex items-center rounded-full border border-ink/15 px-4 py-2 text-sm font-medium text-ink transition-colors hover:bg-ink/5 dark:border-paper/20 dark:text-paper dark:hover:bg-paper/5"
            >
              {copy.privateLink}
            </Link>
            <Link
              to={lp + "/use-cases/no-plugin-meeting-transcription"}
              className="inline-flex items-center rounded-full border border-ink/15 px-4 py-2 text-sm font-medium text-ink transition-colors hover:bg-ink/5 dark:border-paper/20 dark:text-paper dark:hover:bg-paper/5"
            >
              {copy.noBotLink}
            </Link>
          </div>
        </div>

        <div className="rounded-2xl border border-margin bg-white/70 p-4 shadow-sm dark:border-paper/10 dark:bg-paper/5 sm:p-6">
          <ol className="grid gap-3">
            {copy.steps.map((step, index) => (
              <li
                key={step.title}
                className="grid gap-4 rounded-xl border border-ink/10 bg-paper p-4 dark:border-paper/10 dark:bg-ink/70 sm:grid-cols-[3rem_1fr]"
              >
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-ink font-mono text-xs text-paper dark:bg-paper dark:text-ink">
                  {String(index + 1).padStart(2, "0")}
                </div>
                <div>
                  <h3 className="font-display text-lg font-semibold text-ink dark:text-paper">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink/70 dark:text-paper/70">
                    {step.body}
                  </p>
                </div>
              </li>
            ))}
          </ol>

          <p className="mt-5 rounded-xl bg-graphite/10 px-4 py-3 text-sm leading-relaxed text-ink/70 dark:bg-paper/10 dark:text-paper/70">
            {copy.caveat}
          </p>
        </div>
      </div>
    </section>
  );
}
